import * as React from 'react';
import { Modal } from '@nexus/lib-react/dist/core/Modal/Modal';
import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import styled from '@nexus/lib-react/dist/theme/styled';
import { Headline3, Paragraph4 } from '@nexus/lib-react/dist/core/Typography';
import { Link } from '@nexus/lib-react/dist/core/Button/ButtonBase';
import MoneyRefund from '@olxeu-a2b/ui/src/commons/components/icons/MoneyRefund';
import { useI18n } from '../../../../i18n';

export interface SwitchToBusinessAccountModalProps {
  handleCloseModal: () => void;
  switchToBusinessAccountUrl: string;
}

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SwitchToBusinessAccountModal = ({
  handleCloseModal,
  switchToBusinessAccountUrl,
}: SwitchToBusinessAccountModalProps) => {
  const i18n = useI18n();

  return (
    <Modal
      padding="s"
      position="center"
      onClose={handleCloseModal}
      footer={
        <Modal.Footer>
          <ButtonTertiaryDark onClick={handleCloseModal}>
            {i18n`dlv_statusKyc_userTypeModal_secondaryButton`}
          </ButtonTertiaryDark>
          <ButtonPrimaryDark ml="40px" as={Link} href={switchToBusinessAccountUrl}>
            {i18n`dlv_statusKyc_userTypeModal_primaryButton`}
          </ButtonPrimaryDark>
        </Modal.Footer>
      }
    >
      <Container>
        <MoneyRefund />
        <Headline3 mt="24px" mb="16px">
          {i18n`dlv_statusKyc_userTypeModal_title`}
        </Headline3>
        <Paragraph4 mb="24px">{i18n`dlv_statusKyc_userTypeModal_description`}</Paragraph4>
      </Container>
    </Modal>
  );
};

export default SwitchToBusinessAccountModal;
